import { TypeTestRegion } from "../enums"

export const CORE_MANUFACTURER_REG = "coreDeviceDetailManufacturer"
export const CORE_MODEL_REG = "coreDeviceDetailModel"
export const CORE_CATEGORY_REG = "coreDeviceDetailCategory"
export const CORE_TYPE_REG = "coreDeviceDetailType"
export const CORE_CAPACITY_REG = "coreDeviceDetailCapacity"
export const CORE_PHASES_REG = "coreDeviceDetailPhases"
export const CORE_SOFTWARE_VERSION_REG = "coreDeviceDetailSoftwareVersion"
export const CORE_HARDWARE_VERSION_REG = "coreDeviceDetailHardwareVersion"
export const CORE_ADDITIONAL_COMMENTS_REG = "coreDeviceDetailadditionalComments"

export type TypeTestStandard = {
    name: string
    displayName: string
    region: TypeTestRegion
    canBePartiallyTested: boolean
    canBeFullyTested: boolean
}

export const typeTestStandards: TypeTestStandard[] = [
    {
        name: "G98",
        displayName: "G98",
        region: TypeTestRegion.greatBritain,
        canBePartiallyTested: false,
        canBeFullyTested: true,
    },
    {
        name: "G98_NI",
        displayName: "G98 NI",
        region: TypeTestRegion.northernIreland,
        canBePartiallyTested: false,
        canBeFullyTested: true,
    },
    {
        name: "G99A",
        displayName: "G99A",
        region: TypeTestRegion.greatBritain,
        canBePartiallyTested: true,
        canBeFullyTested: true,
    },
    {
        name: "G99A_NI",
        displayName: "G99A NI",
        region: TypeTestRegion.northernIreland,
        canBePartiallyTested: true,
        canBeFullyTested: true,
    },
    {
        name: "G99B",
        displayName: "G99B",
        region: TypeTestRegion.greatBritain,
        canBePartiallyTested: true,
        canBeFullyTested: true,
    },
    {
        name: "G99B_NI",
        displayName: "G99B NI",
        region: TypeTestRegion.northernIreland,
        canBePartiallyTested: true,
        canBeFullyTested: true,
    },
    {
        name: "G99C",
        displayName: "G99C",
        region: TypeTestRegion.greatBritain,
        canBePartiallyTested: true,
        canBeFullyTested: true,
    },
    {
        name: "G99C_NI",
        displayName: "G99C NI",
        region: TypeTestRegion.northernIreland,
        canBePartiallyTested: true,
        canBeFullyTested: true,
    },
    {
        name: "G99D",
        displayName: "G99D",
        region: TypeTestRegion.greatBritain,
        canBePartiallyTested: true,
        canBeFullyTested: true,
    },
    {
        name: "G99D_NI",
        displayName: "G99D NI",
        region: TypeTestRegion.northernIreland,
        canBePartiallyTested: true,
        canBeFullyTested: true,
    },
    {
        name: "G100",
        displayName: "G100",
        region: TypeTestRegion.greatBritain,
        canBePartiallyTested: false,
        canBeFullyTested: true,
    },
    {
        name: "G100_NI",
        displayName: "G100 NI",
        region: TypeTestRegion.northernIreland,
        canBePartiallyTested: false,
        canBeFullyTested: false,
    },
]

export const registerDeviceLabelMapping: { [key: string]: string } = {
    [CORE_MODEL_REG]: "Model Name/Number",
    [CORE_CATEGORY_REG]: "Device Category",
    [CORE_TYPE_REG]: "Device Type",
    [CORE_CAPACITY_REG]: "Registered Capacity (kW)",
    [CORE_PHASES_REG]: "No. of Phases",
    [CORE_SOFTWARE_VERSION_REG]: "Software Version",
    [CORE_HARDWARE_VERSION_REG]: "Hardware Version",
    [CORE_ADDITIONAL_COMMENTS_REG]: "Additional Comments",
    [CORE_MANUFACTURER_REG]: "Manufacturer",
}

export const NON_SYS_ADMIN_STEPS = [
    "Core Device Details",
    "Type Test Details",
    "Upload Supporting Files",
    "Review and Submit",
]
export const SYS_ADMIN_STEPS = ["Manufacturer"]
